import { render, staticRenderFns } from "./IconCircleCheckBig.vue?vue&type=template&id=4a78d545"
import script from "./IconCircleCheckBig.vue?vue&type=script&lang=js"
export * from "./IconCircleCheckBig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports